import {isObject, isString} from "../utils/checking.util";
import STATUS_CODES from '../constants/status_codes.constants';

export default class NMComErrorResponse {
	_status = "";
	_message = undefined;
	_error = undefined;
	_response = undefined;
	_validations = undefined;

	static generate(error, response) {
		const errorResponse = new NMComErrorResponse();

		if(!isObject(error)) {
			error = {};
		}

		if(!isObject(response)) {
			response = {};
		}

		let responseBody = response ? response.body : undefined;

		if(!isObject(responseBody)) {
			responseBody = {};
		}

		errorResponse.status = responseBody['status'] || error['status'] || response['statusCode'] || '500';
		errorResponse.message = responseBody['message'] || error['message'] || response['body'] || undefined;
		errorResponse.validations = responseBody['validations'] || undefined;
		errorResponse.response = response;
		errorResponse.error = error;

		return errorResponse;
	}

	get status() {
		return this._status;
	}

	set status(value) {
		if(!value) {
			value = "";
		}

		if(!isString(value)) {
			value = value.toString();
		}

		if(STATUS_CODES.hasOwnProperty(value)) {
			this._status = value;
		} else {
			throw new Error(`Invalid status code '${value}' given.`);
		}
	}

	get statusMessage() {
		return STATUS_CODES[this.status] || "Invalid Status Code";
	}

	get message() {
		return (this._message || this.statusMessage);
	}

	set message(value) {
		this._message = value;
	}

	get error() {
		return this._error;
	}

	set error(value) {
		this._error = value
	}

	get response() {
		return this._response;
	}

	set response(value) {
		this._response = value;
	}

	get validations() {
		return this._validations;
	}

	set validations(value) {
		this._validations = value;
	}
}
